export enum EPaymentStatus {
  ABERTA = 1,
  EM_PROCESSAMENTO = 2,
  PAGA = 3,
  CANCELADA = 4,
  AGUARDANDO_DOCUMENTACAO = 5,
  AGUARDANDO_REEMBOLSO = 6,
  REEMBOLSADO = 7,
  EM_ANALISE = 8,
  DUPLICADA = 9,
  EXPIRADA = 10,
  EM_RECUPERACAO = 11,
  USO_INTERNO = 12,
  TRIAL = 13,
  DELETADO = 14,
  AGUARDANDO_PAGAMENTO = 15,
  RECUSADO = 16,
  INADIMPLENTE = 17,
  AGENDADA = 18,
  NEGOCIADA = 19,
}
export enum ECardBrand {
  VISA = 'Visa',
  MASTERCARD = 'Mastercard',
  ELO = 'Elo',
  AMEX = 'Amex',
  OTHER = 'Outro',
}

export enum EMethodType {
  CREDIT = 'Credito',
  DEBIT = 'Debito',
}

export interface IPaymentStatus {
  id: number;
  name: string;
  alias: string;
}

export interface IPaymentMethod {
  id: number;
  name: EMethodType;
}

export interface ICoupon {
  id: number;
  key: any;
  value: any;
}

export interface ICart {
  id: number;
  key: string;
  utm_source: any;
  utm_campaign: any;
  utm_medium: any;
  utm_content: any;
}

export interface ICustomer {
  id: number;
  name: string;
  email: string;
  celphone: string;
}

export interface IAffiliate {
  id: number;
  name: string;
  email: string;
}

export class IProduct {
  id: number;
  title: string;
  coproducer_id: number;
  producer_id: number;
  charge_type: string;
}

export interface ICurrency {
  id: number;
  name: string;
  code: string;
  currency_simbol: string;
}

export interface IInvoiceAnticipation {
  daily_fee: number;
  description: string;
  fee: number;
  initial_fee: number;
  invoice_id: number;
  net_gain: number;
  payment_method: string;
  value: number;

  //usado apenas no front
  selected: boolean;
}

export interface IInvoiceTags {
  upsell: boolean;
  order_bump: boolean;
  quick_sale: boolean;
  is_terminal: boolean;
  chargeback: boolean;
  partial_refund: boolean;
  installment_commission: boolean;
  recovered: boolean;
  multiple_cards: boolean;
  interest_free_installment: boolean;
  unlimited_installment: boolean;
  infinite_funnel: boolean;
  coupon: string;
  recurrence: boolean;
  courtesy_recovered: boolean;
  free: boolean;
  one_click_buy: boolean;
}

export interface IInvoice {
  invoice_id: number;
  id: number;
  payment_status: IPaymentStatus;
  payment_method: IPaymentMethod;
  coupon: ICoupon;
  card_brand: ECardBrand;
  installments: number;
  chargeback: boolean;
  recovery: boolean;
  created_at: Date;
  expired_at: any;
  refunded_at: any;
  transaction_value: number;
  quotation_value: number;
  receive_at: any;
  sale_value: number;
  rate_amount: number;
  comission_amount: number;
  partner_amount: number;
  amount: number;
  anticipation_amount: number;
  refunded_amount: number;
  net_income: number;
  others_values: number;
  credited_at: Date;
  contract_id: number;
  infinity_funnel: boolean;
  multiple_cards: boolean;
  interest_free_installment: boolean;
  unlimited_installment: boolean;
  cart: ICart;
  checkout_recovery_link: any;
  boleto_recovery_link: any;
  customer: ICustomer;
  affiliate: IAffiliate;
  product: IProduct;
  currency: ICurrency;
  comission_type: string;
  other_values2: number;
  credit_installments_date: Date;
  order_bump: boolean;
  upsell: boolean;
  refund_values: any;
  can_refund: boolean;
  can_refund_reason: string;
  tags: IInvoiceTags;
}
